import { Badge } from "@/components/ui/badge";

export const RoadmapTimeline = () => {
  return (
    <div className="relative">
      <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-primary/20"></div>

      {/* Q4 2023 - Launched */}
      <div className="relative pl-16 pb-12">
        <div className="absolute left-6 w-4 h-4 bg-primary rounded-full transform -translate-x-1/2"></div>
        <div className="bg-muted p-6 rounded-lg relative">
          <Badge className="absolute -top-3 bg-primary text-white">Launched Q4 2023</Badge>
          <h4 className="text-lg font-semibold mt-2 mb-3">Core Platform Launch</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li>• Hotel AI Consultant (Hoteliers – English/Arabic)</li>
            <li>• Hotel Classifier (Hoteliers – English/Arabic)</li>
            <li>• Bidding Process: Hotelier (Hoteliers)</li>
            <li>• Bidding Process: Supplier (Suppliers – Multilingual: English/Arabic/Chinese)</li>
            <li>• Bidding Process: Admin (Internal Operations)</li>
            <li>• Mobile-Responsive Design (All Stakeholders)</li>
          </ul>
        </div>
      </div>

      {/* Q2 2024 - In Progress */}
      <div className="relative pl-16 pb-12">
        <div className="absolute left-6 w-4 h-4 bg-primary/60 rounded-full transform -translate-x-1/2"></div>
        <div className="bg-muted p-6 rounded-lg relative">
          <Badge className="absolute -top-3 bg-primary/60 text-white">In Progress - Q2 2024</Badge>
          <h4 className="text-lg font-semibold mt-2 mb-3">Enhanced Features & AI Integration</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li>• AI-Powered Demand Forecasting (Hoteliers)</li>
            <li>• Multi-Property Management (Hotel Groups)</li>
            <li>• Advanced Analytics & Reporting (Hoteliers & Regulators)</li>
            <li>• Custom Integration APIs (Suppliers & Regulators)</li>
            <li>• Fintech Integration for Trade Finance and BNPL</li>
          </ul>
        </div>
      </div>

      {/* Q3 2024 - Planned */}
      <div className="relative pl-16 pb-12">
        <div className="absolute left-6 w-4 h-4 bg-primary/40 rounded-full transform -translate-x-1/2"></div>
        <div className="bg-muted p-6 rounded-lg relative">
          <Badge className="absolute -top-3 bg-primary/40 text-white">Planned - Q3 2024</Badge>
          <h4 className="text-lg font-semibold mt-2 mb-3">Expanded Offerings & User Engagement</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li>• Expanded Multilingual Support for Suppliers: Hindi, French, Italian, and Spanish</li>
            <li>• Catalog Management System (Suppliers & Hoteliers)</li>
            <li>• Investor Portal (Investors)</li>
          </ul>
        </div>
      </div>

      {/* Q4 2024 - Planned */}
      <div className="relative pl-16 pb-12">
        <div className="absolute left-6 w-4 h-4 bg-primary/40 rounded-full transform -translate-x-1/2"></div>
        <div className="bg-muted p-6 rounded-lg relative">
          <Badge className="absolute -top-3 bg-primary/40 text-white">Planned - Q4 2024</Badge>
          <h4 className="text-lg font-semibold mt-2 mb-3">Enterprise Solutions</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li>• Automated Procurement System (Hoteliers & Suppliers)</li>
            <li>• Predictive Maintenance (Hoteliers)</li>
            <li>• Real-time Inventory Tracking (Suppliers – Multilingual: All Supported Languages)</li>
            <li>• Advanced Security Features (All Stakeholders)</li>
          </ul>
        </div>
      </div>

      {/* 2025 - Future Vision */}
      <div className="relative pl-16">
        <div className="absolute left-6 w-4 h-4 bg-primary/20 rounded-full transform -translate-x-1/2"></div>
        <div className="bg-muted p-6 rounded-lg relative">
          <Badge className="absolute -top-3 bg-primary/20 text-white">Future Vision - 2025</Badge>
          <h4 className="text-lg font-semibold mt-2 mb-3">Global Expansion & Innovation</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li>• Blockchain Integration (Investors & Regulators)</li>
            <li>• IoT Device Integration (Hoteliers)</li>
            <li>• Advanced AI Recommendations (Hoteliers & Regulators)</li>
            <li>• Global Marketplace Launch (Suppliers & Investors)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};